'use client';

import React from 'react';
import { Sheet, Stack, iconButtonClasses } from '@castlery/fortress';
import { UserMenu } from './components/user-menu/user-menu';
import { FlexSearchBar } from './components/flex-search-bar/flex-search-bar';
import { FavoriteButton } from './components/favorite-button/favorite-button';
import { ShoppingBagButton } from './components/shopping-bag-button/shopping-bag-button';

const WebUserBar = () => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        gap: '16px',
        // position: 'absolute',
        // right: 24,
        // paddingRight: '20px',
        zIndex: 3,
        [`& .${iconButtonClasses.root}`]: {
          minWidth: '',
          paddingInline: 0,
        },
      }}
    >
      <Sheet
        sx={(theme) => ({
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: theme.palette.brand.warmLinen[500],
        })}
      >
        <FlexSearchBar />
      </Sheet>
      <Sheet
        sx={(theme) => ({
          backgroundColor: theme.palette.brand.warmLinen[500],
        })}
      >
        <UserMenu />
      </Sheet>
      <Sheet
        sx={(theme) => ({
          position: 'relative',
          backgroundColor: theme.palette.brand.warmLinen[500],
        })}
      >
        <FavoriteButton />
      </Sheet>
      <Sheet
        sx={(theme) => ({
          paddingTop: '4px',
          backgroundColor: theme.palette.brand.warmLinen[500],
        })}
      >
        <ShoppingBagButton />
      </Sheet>
    </Stack>
  );
};

export { WebUserBar };
